import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
}
export function ProtectedRoute({
  children
}: ProtectedRouteProps) {
  const {
    user,
    loading
  } = useAuth();
  const location = useLocation();
  // Show loading state while checking authentication
  if (loading) {
    return <div role="status" className="flex min-h-screen w-full items-center justify-center bg-[#050505]" data-id="element-1691" data-mp="wsh2b2rvrop2">
        <div className="text-center" data-id="element-1692" data-mp="10tspl1na7xu3">
          <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-[#FF0000] border-t-transparent" data-id="element-1693" data-mp="mujfmjpo5zyk" />
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-gray-400" data-id="element-1694" data-mp="rsur0yvm4iiw">
            Loading…
          </p>
        </div>
      </div>;
  }
  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-1695" data-mp="3clg471c2sv0k" />;
  }
  return <>{children}</>;
}